import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPagedCollectionResult, mapCollection } from '@mango/core';
import { DatePipe } from '@angular/common';

@Injectable()
export class DashboardService {

    constructor(private http: HttpClient) {

    }

    getProjectenPerStatus(): Observable<any[]> {
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/project/get?select=Count(Id),Status&groupBy=Status&orderBy=2&filter=[{"m":1,"p":"Status","v":2}]').pipe(mapCollection()); 
    }

    getProjectregelsPerStatus(): Observable<any[]> {
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/projectregel/get?select=Count(Id),Status&groupBy=Status&orderBy=2&filter=[{"m":7,"p":"Status","v":11},{"m":2,"p":"IsHistorie","v":false}]').pipe(mapCollection());
    }

    getProjectregelsPerWeekAanmaakdatum(year: number): Observable<any[]> {
        
        let url1 = '/api/dto/projectregel/get?select=Count(Id),WeeknummerAanmaak,postType&groupBy=WeeknummerAanmaak,postType&orderBy=2&filter=[{"m":0,"p":"JaarAanmaak","v":' + year + '}]';
        
        return this.http.get<WebApiPagedCollectionResult<any>>(url1).pipe(mapCollection());
    }
    
    getProjectregelsPerAanmaakdatum(): Observable<any[]> {
        
        const now = new Date;
        var monthAgo = new Date;
        monthAgo = this.addMonths(now, -2);

        let url1 = '/api/dto/projectregel/get?select=Count(Id),datumAanmaak&groupBy=datumAanmaak&orderBy=2&filter=[{"m":4,"p":"datumAanmaak","v":"' + monthAgo.toISOString() + '"}]';
        
        return this.http.get<WebApiPagedCollectionResult<any>>(url1).pipe(mapCollection());
    }

    getOproepenMaildatum(year: number): Observable<any[]> {
        
        let url1 = '/api/dto/oproephistorie/get?select=Count(Id),weeknummerMail&groupBy=weeknummerMail&orderBy=2&filter=[{"m":0,"p":"JaarMail","v":' + year + '}]';
        
        return this.http.get<WebApiPagedCollectionResult<any>>(url1).pipe(mapCollection());
    }

    getOproepenPerDatum(): Observable<any[]> {
        
        const now = new Date;
		var plus1month = new Date;

        plus1month = this.addMonths(now, 1);

        let url1 = '/api/dto/oproephistorie/get?select=Count(Id),datumOproep&groupBy=datumOproep&orderBy=2&filter=[{"m":5,"p":"datumOproep","v":"' + plus1month.toISOString() + '"}, {"m":0,"p":"Oproepen","v":true}]';
        
        return this.http.get<WebApiPagedCollectionResult<any>>(url1).pipe(mapCollection());
    }

    getHerOproepenPerDatum(): Observable<any[]> {
        
        let url2 = '/api/dto/oproephistorie/get?select=Count(Id),datumOproep&groupBy=datumOproep&orderBy=2&filter=[{"m":0,"p":"HerOproepen","v":true}]';
        
        return this.http.get<WebApiPagedCollectionResult<any>>(url2).pipe(mapCollection());
    }

    getAantalFactureren(): Observable<any[]> {      
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/pakbon/get?select=Count(Id)&filter=[{"m":0,"p":"TeFactureren","v":0}]').pipe(mapCollection());
    }

    getAantalProForma(): Observable<any[]> {      
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/pakbon/get?select=Count(Id)&filter=[{"m":0,"p":"TeFactureren","v":0}, {"m":0,"p":"hasProFormaFactuur","v":true}]').pipe(mapCollection());
    }

    getAantalVerzenden(): Observable<any[]> {      
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/factuur/get?select=Count(Id)&filter=[{"m":1,"p":"GoedgekeurdOp","v":null}, {"m":0,"p":"NaarExactOp","v":null}, {"m":0,"p":"MailDatum","v":null}]').pipe(mapCollection());
    }

    getAantalGoedkeuren(): Observable<any[]> {      
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/factuur/get?select=Count(Id)&filter=[{"m":0,"p":"GoedgekeurdOp","v":null}]').pipe(mapCollection());
    }

    getAantalExporteren(): Observable<any[]> {      
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/factuur/get?select=Count(Id)&filter=[{"m":0,"p":"NaarExactOp","v":null},{"m":1,"p":"GoedgekeurdOp","v":null}]').pipe(mapCollection());
    }


    addMonths(date, months) {
        let newDate = new Date(date);
        var day = newDate.getDate();
        newDate.setMonth(newDate.getMonth() + +months);
        if (newDate.getDate() != day)
            newDate.setDate(0);
        return newDate;
      } 

}